import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import PromoPage from '../pages/PromoPage';
import '../style.css';
import '../color.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function AppRoute() {
  const renderPromoAtRoot = shouldRenderPromoPageAtRoot();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={renderPromoAtRoot ? <PromoPage /> : <Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/:previewHost/:alias" element={<PromoPage />} />
        <Route path="/:alias" element={<PromoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

function shouldRenderPromoPageAtRoot() {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = String(window.location.hostname || '').trim().toLowerCase();

  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return false;
  }

  const parts = hostname.split('.').filter(Boolean);

  if (parts[parts.length - 1] === 'localhost') {
    const localParts = parts.slice(0, -1);
    return localParts.length > 1 && !['www', 'promo'].includes(localParts[0]);
  }

  return parts.length > 2 && !['www', 'promo'].includes(parts[0]);
}

export default AppRoute;
